module.exports = __webpack_public_path__ + "img/nothing.a14cd4bc.svg";